import { render } from "./L_WriteLetter.vue?vue&type=template&id=b01d66bc"
import script from "./L_WriteLetter.vue?vue&type=script&lang=js"
export * from "./L_WriteLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__